module.exports = __webpack_public_path__ + "static/media/KS.e8d1a4cf.png";